
<template>
  <div class="profile-container">
    <div class="profile-main-content">
      <h1>
        パスワードを忘れた方
        <span>Reset Password</span>
      </h1>
      
       <div v-if="ShowResultOK" class="result-ok-content">
           <i class="far fa-check-circle"></i>
           パスワードリセットの案内メールを送信したよ！
           <div class="ok-button" @click="GoBack">
            <i class="fas fa-chevron-left"></i>
            OK
        </div>
       </div>
      <!-- =======================
        メール:
      =======================-->
      <!-- メールの編集 -->
      <div v-if="false === ShowResultOK" class="row-input loading-container">
        
        <!-- ローディング -->
        <t-loading class="loading-item" :isLoading="IsLoadingEmail"></t-loading>
        <t-input
          v-model="ruleForm.email"
          v-validate="'required|email|max:254'"
          ref="inputEmail"
          name="email"
          :enterToEditEnd="false"
          v-bind:class="{disable:IsLoadingEmail}"
          :maxlength="254"
          placeholder="メールアドレス"
          inputType="text"
          label="・メールアドレス"
          iconClassName="fas fa-envelope"
          :isShowErrorMessage="errors.has('email')"
          :errorMessage="errors.first('email')"
          radius="20px"
        ></t-input>

        <!-- ボタン類 -->
        <div class="row-buttons">
          <div
            @click="SendResetPassword"
            v-bind:class="{disable:IsLoadingEmail　|| errors.has('email')  }"
            class="button-edit"
          >
            <i class="fas fa-share-square"></i>
            パスワードをリセット
          </div>
        </div>

        <div class="back" @click="GoBack">
          <i class="fas fa-chevron-left"></i>
          やめる
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TInput from "../TInput";
import Tloading from "../TLoading";


//検証メッセージのカスタマイズ処理
import { Validator } from "vee-validate";
const dict = {
  custom: {
    email: {
      required: "メールアドレスをいれてね！",
      email: "ただしいメールアドレスをいれてね！",
      max: "※ 254文字以内でいれてね"
    }
  }
};
Validator.localize("ja", dict);
export default {
  name: "RequestResetPasswordPage",
  components: {
    TInput,
    "t-loading": Tloading
  },

  data() {
    return {
      IsLoadingEmail: false,
      message: "",
      ShowResultOK:false,
      ruleForm: {
        email: ""
      }
    };
  },
  mounted() {
    this.ruleForm.email = "";
    this.ShowResultOK = false;
    this.$refs.inputEmail.ToFocus();
  },
  methods: {
    //========================
    //１つ前のページへ戻る
    //========================
    GoBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
    },
    SendResetPassword() {
      //値の検証
      this.$validator
        .validate("email")
        .then(result => {
          if (result) {
            this.ResetPassword(this.ruleForm.email);
          }
        })
        .bind(this);
    },
    ResetPassword(email) {
      this.IsLoadingEmail = true;
      firebase
        .auth()
        .sendPasswordResetEmail(email)
        .then(
          () => {
            this.ShowResultOK = true;
            this.IsLoadingEmail = false;
          },
          err => {
            alert(
              "入力したメールアドレスは使われていないよ！まちがってないか確認してね！"
            );
            this.IsLoadingEmail = false;
          }
        )
        .bind(this);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.profile-container {
  outline-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.profile-main-content {
}

.ok-button{
    text-align: center;

  display: block;
  font-size: 22px;
  text-decoration: none;
  margin-top: 20px;
  & > i {
    margin-right: 8px;
  }
  &:hover {
    color: coral;
  }

  color: #42b983;
  cursor: pointer;
}



.back {
  text-align: left;
  margin-top:20px;

  display: inline-block;
  font-size: 16px;
  text-decoration: none;
  margin-bottom: 8px;
  & > i {
    margin-right: 8px;
  }
  &:hover {
    color: coral;
  }

  color: #42b983;
  cursor: pointer;
}

.result-ok-content{
    margin-top:20px;
    color: #42b983;
    font-size:16px;
    font-weight: 600;
    text-align: center;

    & > i{
        display:block;
        font-size:80px;
        margin-bottom:40px;
    }

}

//---------------
// :無効時のスタイル
//---------------
.disable {
  opacity: 0.3;
  cursor: default;
  pointer-events: none; // クリック、タッチを無効化
  // -文字を選択させない
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}

.loading-container {
  position: relative;
  .loading-item {
    position: absolute;
    top: 40px;
    left: 80px;
    z-index: 999;
    transform: scale(1);
  }
}

.row-input{
    width:600px;
 
}

h1,
h2 {
  font-weight: 800;
  display: inline-block;
  //縁取り文字
  color: yellow;
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: #666;

  & > span {
    display: block;
    text-align: center;
    font-weight: normal;
    font-size: 16px;
  }
}

//--------------
//ボタン:送信する
//--------------
.button-edit {
  cursor: pointer;
  margin-top:5px;
  color: #fff;
  display: inline-block;
  //border: 1px solid #42b983;
  background: #42b983;
  text-align: center;
  border-radius: 20px;
  padding-top: 15px;
  padding-bottom:5px;
  padding-left: 20px;
  padding-right: 18px;
  height: 25px;
  vertical-align: middle;
  letter-spacing: 32x;
  font-weight: 600;
  font-size: 16px;
  transition: all 200ms 0s ease;
  box-shadow: 0px 3px #228659;

  &.cancel {
    background: #fff;
    color: #42b983;
  }

  &:hover {
    background:#228659;
  }

  & > i {
    margin-right: 5px;
    font-weight: normal;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/RequestResetPasswordPage.vue